module.exports = __webpack_public_path__ + "img/sv30.ca49f3fa.svg";